'use strict';

var React = require('react');

var SvgIncentiveIcon = function SvgIncentiveIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9.966 4.59a.288.288 0 0 0-.417 0l-3.415 3.482a.323.323 0 0 0-.068.362c.05.126.15.195.277.195h1.458l1.491 7.118a.308.308 0 0 0 .296.253h.339a.308.308 0 0 0 .295-.253l1.491-7.118h1.46c.128 0 .227-.07.278-.195a.323.323 0 0 0-.069-.362l-3.416-3.483Zm-1.488-1.05a1.788 1.788 0 0 1 2.56-.001l3.415 3.482c1.108 1.13.353 3.108-1.28 3.108h-.241l-1.242 5.926a1.808 1.808 0 0 1-1.763 1.445h-.34a1.808 1.808 0 0 1-1.763-1.445l-1.241-5.926h-.24c-1.632 0-2.387-1.978-1.28-3.107l3.415-3.483Zm-3.948 8.092a.75.75 0 0 1 .937.497l1.316 4.293a.75.75 0 1 1-1.434.44l-1.316-4.293a.75.75 0 0 1 .497-.937Zm10.399-.012a.75.75 0 0 1 .55.907l-1.053 4.293a.75.75 0 0 1-1.457-.357l1.053-4.293a.75.75 0 0 1 .907-.55Z"
  }));
};
SvgIncentiveIcon.displayName = "IncentiveIcon";

exports.SvgIncentiveIcon = SvgIncentiveIcon;
